/* =============================================================================
   Formatting helpers — ported from the shared js/normax-crm.js engine.
   ============================================================================= */

const SYMBOLS: Record<string, string> = { EUR: '€', USD: '$', GBP: '£' };

export function formatCurrency(value: number, currency = 'EUR'): string {
  const symbol = SYMBOLS[currency] ?? currency + ' ';
  if (value >= 1_000_000) {
    return symbol + (value / 1_000_000).toFixed(value % 1_000_000 === 0 ? 0 : 1) + 'M';
  }
  if (value >= 1_000) {
    return symbol + (value / 1_000).toFixed(0) + 'k';
  }
  return symbol + value.toLocaleString('en-GB');
}

export function formatDate(d: Date | string): string {
  const date = typeof d === 'string' ? new Date(d) : d;
  return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function formatRelative(d: Date | string): string {
  const date = typeof d === 'string' ? new Date(d) : d;
  const diffMs = Date.now() - date.getTime();
  const diffDays = Math.floor(diffMs / 86_400_000);
  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return diffDays + ' days ago';
  if (diffDays < 30) return Math.floor(diffDays / 7) + ' weeks ago';
  if (diffDays < 365) return Math.floor(diffDays / 30) + ' months ago';
  return Math.floor(diffDays / 365) + ' years ago';
}

/**
 * Fine-grained "time ago" (minutes/hours), for timestamps where day-level
 * granularity (`formatRelative`) is too coarse — e.g. notifications. Falls
 * back to `formatRelative` beyond a week.
 */
export function formatTimeAgo(d: Date | string): string {
  const date = typeof d === 'string' ? new Date(d) : d;
  const diffSec = Math.floor((Date.now() - date.getTime()) / 1000);
  if (diffSec < 60) return 'Just now';
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHours = Math.floor(diffMin / 60);
  if (diffHours < 24) return `${diffHours}h ago`;
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 7) return `${diffDays}d ago`;
  return formatRelative(date);
}
